import { useEffect, useRef } from 'react';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { LoadingKey } from '../app-active-loading/LoadingKey';
import { setError } from '../store/error/action-creators';
import { useAppDispatch } from './useAppDispatch';
let timerId;
export const clearErrorTimeoutForTesting = () => {
  clearTimeout(timerId);
  timerId = undefined;
};
export const useSetErrorAfterTimeout = (loadingKey, delay = 10000, errorKey = ErrorKey.BlankScreenLoadingError) => {
  const isBlankLoadingScreen = loadingKey === LoadingKey.BlankScreenLoading;
  const dispatch = useAppDispatch();
  const timeoutId = useRef(-1);
  useEffect(() => {
    if (!isBlankLoadingScreen || timeoutId.current) return () => {};

    const setErrorKey = () => {
      dispatch(setError(errorKey));
    };

    timeoutId.current = setTimeout(setErrorKey, delay);
    return () => {
      clearTimeout(timeoutId.current);
    };
  }, [delay, dispatch, errorKey, isBlankLoadingScreen]);
};